<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 7548 7549"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0" d="M7217 3774c0,-172 139,-312 312,-312 6,0 13,2 19,2 -149,-1840 -1614,-3308 -3454,-3462 1,10 3,20 3,30 0,172 -139,312 -312,312 -172,0 -312,-140 -312,-312 0,-11 3,-21 4,-32 -1852,144 -3328,1618 -3477,3467 150,23 265,151 265,307 0,156 -115,285 -265,307 149,1850 1625,3323 3477,3468 -1,-11 -4,-21 -4,-32 0,-173 140,-312 312,-312 173,0 312,139 312,312 0,10 -2,20 -3,30 1840,-154 3305,-1622 3454,-3463 -6,1 -13,2 -19,2 -173,0 -312,-139 -312,-312zm-1340 1788l0 0c-44,56 -109,86 -175,86 -48,0 -96,-16 -137,-47l-2090 -1629 0 -1929c0,-123 99,-222 222,-222 122,0 222,99 222,222l0 1712 1919 1496c97,75 114,214 39,311z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'TimeUpdate',
};
</script>

<style scoped>
.fil0 {fill:#1DAAE1;fill-rule:nonzero}
</style>
